import { Map } from 'immutable';
import Occasion from '@support/Occasion';
import BaseObject from './BaseObject';
import { ID } from '@app/types';

type ShareType = 'verified' | 'waiting';

export class Sharee<PermissionType> extends BaseObject {
  email: string;
  shareType: ShareType;
  created: Occasion;
  displayName?: string;
  avatarURL?: string;
  permissionsMap: Map<PermissionType, ID | null>;

  constructor(props: any = {}) {
    super(props);
    this.id = props.email;
    this.email = props.email;
    this.shareType = props.share_type || props.shareType;
    this.created = new Occasion(props.created);
    this.displayName = props.display_name || props.displayName;
    this.avatarURL = props.avatar_url || props.avatarURL;

    if (props.permissions) {
      this.permissionsMap = Map(props.permissions.map((p) => [p.permission, p.id]));
    } else {
      this.permissionsMap = props.permissionsMap || Map();
    }
  }

  addPermission(permissionType: PermissionType, permissionID?: number | string) {
    return this.copyWith({
      permissionsMap: this.permissionsMap.set(
        permissionType,
        permissionID ? String(permissionID) : null,
      ),
    });
  }

  removePermission(permissionType: PermissionType) {
    return this.copyWith({ permissionsMap: this.permissionsMap.delete(permissionType) });
  }

  removePermissionByID(permissionID: ID) {
    return this.removePermission(this.permissionForID(permissionID));
  }

  idForPermission(permissionType: PermissionType) {
    return this.permissionsMap.get(permissionType);
  }

  permissionForID(permissionID: ID) {
    return this.permissionsMap.findKey((id) => id == permissionID);
  }

  get idForMainPermission(): ID {
    console.error('Getter `idForMainPermission` must be overridden by subclass');
    return undefined;
  }
}
